import { StoreState } from '../../../app/app.reducers';

export const getUserRatings = (store: StoreState) => store.rating.ratings;
export const getOfferAverageRating = (store: StoreState) => store.rating.avgRating || 0;
export const getOfferTotalRatings = (store: StoreState) => store.rating.ratings.length || 0;
export const getUserBadges = (store: StoreState) => store.rating.badges;
export const getForm = (state: StoreState) => state.rating.form?.target;
export const getFormResult = (state: StoreState) => state.rating.form?.rating;
